<template>
  <div>
    <p style="position: relative; top: 205px; left: 0; text-align: center;">
      {{ unit }}
    </p>
  <v-chart
    class="chart"
    :option="getChartOption()"
    :loading="loading"
    :theme="isDarkTheme? 'dark' : 'light'"
     :group="group"
  />
</div>
</template>

<script>
import { ColorTheme } from '../../../src/mixins/ColorTheme';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
  TooltipComponent,
  LegendComponent
} from 'echarts/components';
import VChart from 'vue-echarts';

use([
  CanvasRenderer,
  PieChart,
  TooltipComponent,
  LegendComponent
]);

export default {
  name: 'analysetool-piechart',
  components: {
    VChart
  },
  mixins: [ColorTheme],
  props: {
    /**
     * Data source containing the actual data for the chart.
     */
    dataSource: { type: Array, required: true },
    /**
     * Name of the label column of the data set.
     */
    labelColumn: { type: String, required: true },
    /**
     * Name of the value column of the data set.
     */
    valueColumn: { type: String, required: true },
    /**
     * Unit of measurement
     */
    unit: { type: String, required: false },
    /**
     * Show the loading indicator.
     */
    loading: { type: Boolean, required: false, default: false },
    /**
     * Chart group ID for connecting charts.
     */
    group: { type: String, required: false, default: undefined }
  },
  data () {
    return {
      /* eslint-disable */
      /* Otherwise very ugly mixture of quoted and unquoted props */
      colorMapping: {
        'Biogener Abfall': '#008800',
        'Biomethan': '#fee1b8',
        'Braunkohle': '#636663',
        'Deponiegas': '#d4c692',
        'Erdgas': '#bcad9f',
        'Feste Biomasse': '#de9f47',
        'Flüssige Biomasse': '#819447',
        'Flüssiggas': '#2f4d2f',
        'Gasförmige Biomasse (insb. Biogas)': '#44702d',
        'Grubengas': '#3d3333',
        'Heizöl': '#eb9661',
        'Klärgas': '#a6b04f',
        'Nichtbiogener Abfall': '#593e47',
        'Oberflächennahe Geothermie': '#546756',
        'Solarthermie': '#777777',
        'Steinkohle': '#87857c',
        'Strom': '#fdd179',
        'Tiefe Geothermie': '#89a477',
        'Umweltwärme aus Abwasser': 'rgb(175, 209, 168)',
        'Umweltwärme aus Grubenwasser': '#cae6d9',
        'Umweltwärme aus Luft': '#f1f6f0',
        'Umweltwärme aus Oberflächengewässern': '#a4c5af',
        'Unvermeidbare Abwärme': '#a57855',
        'Wasserstoff': '#b55945',
        'Wasserstoffderivate (insb. synthetisches Methan)': '#734c44',
    }
      /* eslint-enable */
    }
  },
  methods: {
    /**
     * Returns the apache echart configuration.
     **/
    getChartOption () {
      return {
        backgroundColor: 'transparent',
        tooltip: {
          confine: true,
          // position: ['35%', '85%'],
          position: 'inside',
          trigger: 'item',
          formatter: p => {
            return (
              p.data.name + ': ' +
              p.data.value.toLocaleString() + ' ' + this.unit
            );
          }
        },
        legend: {
          type: 'scroll',
          show: true,
          data: this.legendData,
          left: 'center',
          top: 0
        },
        dataset: {
          dimensions: [this.labelColumn, this.valueColumn],
          source: this.dataSource
        },
        color: this.dataSource.map(item => this.colorMapping[item.name]),
        series: [{
          data: this.dataSource,
          type: 'pie',
          radius: ['25%', '70%'],
          center: ['50%', '175'],
          emphasis: {
            label: {
              show: true,
              fontSize: 15
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          encode: {
            itemName: [this.labelColumn],
            value: this.valueColumn
          },
          label: {
            show: true,
            hideOverlap: true,
            position: 'inside',
            formatter: p => {
              return (
                p.data.value.toLocaleString()
              );
            }
          },
          labelLayout: {
            moverOverlap: 'shiftY',
            hideOverlap: true
          },
          scaleLimit: {
            min: 0.4,
            max: 2
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderRadius: 5,
            borderColor: '#fff',
            borderWidth: 1
          }
        }]
      };
    }
  }
}
</script>

<style scoped>
.chart {
  height: 280px;
}
</style>
